import ErrorPage from 'next/error'
import { useRouter } from 'next/router'
import { useEffect } from 'react'
import { useDispatch } from 'react-redux'
import ListActions from '../../components/ListActions'
import ListHeader from '../../components/ListHeader'
import ListItem from '../../components/ListItem'
import ListMeta from '../../components/ListMeta'
import Loading from '../../components/Loading'
import { useUser } from '../../hooks'
import { playlistFromList } from '../../lib/player'
import { playerLoad } from '../../redux/actions'
import { getList, getLists } from '../../sequelize/queries/lists'

const ListPage = ({ list }) => {
  const [user, { loading }] = useUser()
  const Router = useRouter()
  const dispatch = useDispatch()

  useEffect(() => {
    // If list is draft and you're not creator, redirect to homepage
    if (
      (!loading && !user && list?.published_at === null) ||
      (!loading &&
        user &&
        list?.published_at === null &&
        user.id != list.user_id)
    ) {
      Router.replace('/')
    }
  }, [list, loading, user])

  const playlist = playlistFromList(list)

  const handlePlay = (playIndex) => {
    dispatch(
      playerLoad({
        list,
        playIndex,
        playlist,
      })
    )
  }

  if (Router.isFallback) return <Loading />

  if (!list) return <ErrorPage statusCode={404} />

  return (
    <>
      <ListMeta list={list} />
      <ListHeader className="mb3" list={list} />

      <ul className="list ma0 ph0 mb3 w-100" style={{ maxWidth: '50rem' }}>
        {list.ListItems.map((listItem, i) => (
          <ListItem
            key={listItem.url}
            listItem={listItem}
            i={i}
            onDelete={(url) => {}}
            play={() => handlePlay(i)}
          />
        ))}
      </ul>

      <ListActions className="mb4" slug={list.slug} />
    </>
  )
}

export async function getStaticPaths() {
  let lists = await getLists({
    page: 1,
    perPage: 200,
  })
  return {
    paths: lists.results.map((list) => ({ params: { slug: list.slug } })),
    fallback: true,
  }
}

export async function getStaticProps(context) {
  const { slug } = context.params
  let list = await getList({ slug })

  return {
    props: {
      list,
    },
  }
}

export default ListPage
